<template>
  <div>
    <a-form :form="form.fc" v-bind="formItemLayout" label-align="right">
      <a-spin :spinning="wiresLoading">
        <a-row :gutter="5" v-for="k in form.fc.getFieldValue('keys')" :key="k">
          <a-col :span="6">
             <a-form-item :label="$t('scope.text_22')">
                <a-select v-decorator="[`${k}.zone`, {
                  ...options.zone,
                  initialValue: (wires && wires[k]) ? wires[k].zone : undefined
                }]" :placeholder="$t('scope.text_65')">
                  <a-select-option v-for="item in zones" :value="item.id" :key="item.id">
                    {{item.name}}
                  </a-select-option>
                </a-select>
             </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('scope.text_21')">
              <a-input v-decorator="[`${k}.name`, {
                ...options.name,
                initialValue: (wires && wires[k]) ? wires[k].name : undefined
              }]" :placeholder="$t('scope.text_38')" />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item :label="$t('scope.text_66')">
              <a-select
                v-decorator="[`${k}.bandwidth`, {
                  ...options.bandwidth,
                  initialValue: (wires && wires[k] && wires[k].bandwidth) ? wires[k].bandwidth.toString() : undefined,
                }]"
                :placeholder="$t('scope.text_67')">
                <a-select-option v-for="(v, k) in $t('bandwidths')" :value="k" :key="k">
                  {{v}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('scope.text_54')">
              <a-input v-decorator="[`${k}.description`, {
                initialValue: (wires && wires[k]) ? wires[k].description : undefined
              }]" :placeholder="$t('scope.text_55')" />
            </a-form-item>
          </a-col>
          <a-col :span="1" v-if="form.fc.getFieldValue('keys').length > 1">
            <a-button @click="handleRemove(k)" shape="circle" icon="minus" size="small" class="mt-2 ml-2" />
          </a-col>
          <a-col :span="24">
            <a-divider class="mt-1" />
          </a-col>
        </a-row>
      </a-spin>
      <a-row :gutter="10">
         <a-col :span="11">
           <a-form-item v-bind="offsetFormItemLayout">
              <a-button type="dashed" style="width: 50%" @click="handleAdd">
                <a-icon type="plus" />{{$t('scope.text_68')}}</a-button>
            </a-form-item>
         </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { getRequestT } from '@/utils/utils'

export default {
  name: 'GuideWire',
  inject: ['offsetFormItemLayout', 'tempData'],
  data () {
    return {
      loading: false,
      wires: {},
      wiresLoading: false,
      zones: [],
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          md: { span: 16 },
          xl: { span: 19 },
          xxl: { span: 19 },
        },
        labelCol: {
          md: { span: 7 },
          xl: { span: 5 },
          xxl: { span: 5 },
        },
      },
      options: {
        zone: {
          // initialValue: 'default',
          rules: [
            { required: true, message: this.$t('scope.text_65') },
          ],
        },
        name: {
          validateFirst: true,
          rules: [
            { required: true, message: this.$t('scope.text_38') },
            { validator: this.$validate('resourceName') },
          ],
        },
        bandwidth: {
          rules: [
            { required: true, message: this.$t('scope.text_69') },
          ],
        },
      },
    }
  },
  created () {
    this.form.fc.getFieldDecorator('keys', { initialValue: [new Date().valueOf()], preserve: true })
    this.manager = new this.$Manager('wires')
    this.queryFetchWires()
    this.queryZones()
  },
  methods: {
    async queryZones () {
      try {
        const { data = {} } = await new this.$Manager('zones').list({
          params: {
            limit: 0,
            cloud_env: 'private_or_onpremise',
            scope: this.$store.getters.scope,
          },
        })
        this.zones = data.data || []
      } catch (err) {
        throw err
      }
    },
    handleAdd () {
      const { fc } = this.form
      const keys = fc.getFieldValue('keys')
      const nextKeys = keys.concat(new Date().valueOf())
      fc.setFieldsValue({
        keys: nextKeys,
      })
    },
    handleRemove (k) {
      const { fc } = this.form
      const keys = fc.getFieldValue('keys')
      fc.setFieldsValue({
        keys: keys.filter(_ => _ !== k),
      })
    },
    async queryFetchWires () {
      this.wiresLoading = true
      try {
        const { data = {} } = await this.manager.list({
          params: {
            limit: 0,
            scope: this.$store.getters.scope,
          },
        })
        const ids = []
        const wires = data.data || []
        if (wires && wires.length > 0) {
          wires.forEach(item => {
            const { id } = item
            ids.push(id)
            this.wires[id] = item
          })
        }
        if (ids && ids.length > 0) {
          const { fc } = this.form
          fc.setFieldsValue({
            keys: ids,
          })
        }
      } catch (err) {
        throw err
      } finally {
        this.wiresLoading = false
      }
    },
    async doSubmit () {
      try {
        const { zone, ...wireParams } = await this.form.fc.validateFields()
        delete wireParams.keys
        const promises = []
        for (const k in wireParams) {
          const params = {
            vpc_id: 'default',
            zone_id: wireParams[k].zone,
            name: wireParams[k].name,
            bandwidth: wireParams[k].bandwidth,
            description: wireParams[k].description,
          }
          promises.push(new Promise((resolve, reject) => {
            if (this.wires && this.wires[k]) {
              this.manager.update({
                id: k,
                data: params,
                params: { $t: getRequestT() },
              }).then(({ data }) => {
                resolve(data)
              }).catch(err => {
                reject(err)
              })
            } else {
              this.manager.create({
                data: params,
                params: { $t: getRequestT() },
              }).then(({ data }) => {
                resolve(data)
              }).catch(err => {
                reject(err)
              })
            }
          }))
        }
        const wire = await Promise.all(promises)
        return ['wire', wire]
      } catch (err) {
        throw err
      }
    },
  },
}
</script>
